import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

declare var numcours: number;
//declare var numeropage: number;


@Injectable({
  providedIn: 'root'
})
export class GfichierService {

  tabPages: any;
  posi: number = -1;
  tabContenu: any;
  title: string = "Titre";
  classe: string = "";
  type: string = "";
  nom: string = "";
  nbPages: number;

  url1 = 'http://sciencesappliquees.com/noncato/';
  url3 = '?template=mobilesommaire';




  constructor(public http: HttpClient) {
 }//fin constructor

  changerPage(): any {
    this.posi++;

    //alert(this.nbPages);

    if (this.posi < this.nbPages)
      return true;
    else
      return false;
  }


  //retourne la page 
  getTabPage() {

    if (this.tabPages[this.posi][0].posi)
       this.posi = this.tabPages[this.posi][0].posi;

    let lgTab = Object.keys(this.tabPages[this.posi]).length;
    //alert(lgTab);
    let tabArray = [];
    //let tab1 : any; 
    //alert(JSON.stringify(tabPage));

    for (let i = 0; i < lgTab; i++) {
      for (let x in this.tabPages[this.posi][i]) {
        tabArray.push({
          id: i,
          key: x,
          value: this.tabPages[this.posi][i][x]
        });
      }
    }//fin for


    return tabArray;
    // alert(this.route.snapshot.paramMap.get("idp"));

  }

//retourne la page 
getPrint() {

  
  let lgTab : number;
  //alert(lgTab);
  let tabArray = [];
  //let tab1 : any; 
  //alert(JSON.stringify(tabPage));

  for (let j = 0; j< this.nbPages; j++) {
    lgTab = Object.keys(this.tabPages[j]).length;
    for (let i = 0; i < lgTab; i++) {
    for (let x in this.tabPages[j][i]) {
      tabArray.push({
        posi:j,
        id: i,
        key: x,
        value: this.tabPages[j][i][x]
      });
    }
  }//fin for
  }//fin for j

  return tabArray;
  // alert(this.route.snapshot.paramMap.get("idp"));

}

getValue(posit:number,id:number,key:string) {
  return this.tabPages[posit][id][key];
}




  pageBack() {
    this.posi--;
    //alert(this.posi);
    //this.router.navigateByUrl('/home');
    //this.router.navigateByUrl(this.tabPages[this.posi].type);
    //this.navCtrl.navigateForward(this.tabPages[this.posi].type);
  }

  
  
  getTitle() {
    if (this.tabPages[this.posi]) {//si tab non defini
      if (this.posi >= 0)
        if (this.tabPages[this.posi][0].title)
          return this.tabPages[this.posi][0].title;
        else
          return "";

    }
    else {
      return ""
    }


  }//fin getTitle

  

  getCode(id:number) {
    if (this.posi >= 0)
      return this.tabPages[this.posi][id].code;
    else 
      return undefined;
  
  }//fin getCode

  getCode2(id:number) {
    if (this.posi >= 0)
      return this.tabPages[this.posi][id].code2;
    else 
      return undefined;
    
  }//fin getCode

  


  setCode2(code: string,id:number) {
    this.tabPages[this.posi][id].code2 = code;
   // alert(JSON.stringify(this.tabPages[this.posi]))
  }//fin getCode

  setQuiz(quiz : any,id:number) {
    this.tabPages[this.posi][id].quiz = quiz;
   // alert(JSON.stringify(this.tabPages[this.posi]))
  }//fin getCode



  setOutput(code: string,id:number) {
    this.tabPages[this.posi][id].output = code;
   // alert(JSON.stringify(this.tabPages[this.posi]))
  }//fin getCode

  getOutput(id:number) {
    if (this.posi >= 0)
      return this.tabPages[this.posi][id].output;
    else 
      return undefined;
    
  }//fin getCode

  setCanvas(code: any,id:number) {
    this.tabPages[this.posi][id].canvas = code;
   // alert(JSON.stringify(this.tabPages[this.posi]))
  }//fin getCode

  setVisiCanvas(visi:boolean,id:number) {
    this.tabPages[this.posi][id].visicanvas = visi;
   // alert(JSON.stringify(this.tabPages[this.posi]))
  }//fin getCode


/*
  geturlav() {
    if (this.posi >= 0)
      return this.tabPages[this.posi].urlav;
  }//fin getCode

  seturlav(code: string) {
    this.tabPages[this.posi].urlav = code;
  }//fin getCode


  geturlap() {
    if (this.posi >= 0 && this.tabPages[this.posi].urlap)
      return this.tabPages[this.posi].urlap;
    else
      return "";
  }//fin getCode

  seturlap(code: string) {
    this.tabPages[this.posi].urlap = code;
  }//fin getCode


  setOutput(code: string) {
    this.tabPages[this.posi].output = code;
  }//fin getCode


  getOutput() {
    return this.tabPages[this.posi].output;
  }//fin getCode



  //quiz 
  setQuizNbquest(nombre: number) {
    this.tabPages[this.posi].nbquest = nombre;
  }//fin getCode

  setQuizNbbonrep(nombre: number) {
    this.tabPages[this.posi].nbbonrep = nombre;
  }//fin getCode

  setQuizJson(monjson: any) {
    this.tabPages[this.posi].jsonquiz = monjson;
  }//fin getCode

  getQuizJson() {

    return this.tabPages[this.posi].jsonquiz;

  }//fin getQuizjson


  setQuizPosi(nombre: number) {
    this.tabPages[this.posi].quizposi = nombre;
  }//fin getCode







  



  getBtvalider() {
    if (this.posi >= 0)
      return this.tabPages[this.posi].btvalider;
  }//fin getBtvalider


  getBack() {
    if (this.posi >= 0) {
      if (this.tabPages[this.posi].back == "true")
        return true;
      else
        return false;
    }
    else return false;
  }//fin getBack
*/

  loadJson(url: string) {

    //alert(numcours);
    let calcul: number = 600 + numcours;
    let adresse = this.url1 + calcul + this.url3;

    return new Promise((resolve, reject) => {
      if (this.tabPages == undefined) {
        this.http.post(adresse, "", {
          headers: new HttpHeaders()
            .set("Content-Type", "application/x-www-form-urlencoded")
        })
          .subscribe(data => {
            //  alert(JSON.stringify(data));
            //alert("aaa");
            this.tabPages = JSON.parse(JSON.stringify(data)); // JSON.parse(JSON.stringify(data));
            this.nbPages = Object.keys(this.tabPages).length;
            //alert(this.nbPages);

            //this.changerPage();
            resolve("ok");
          }, error => {
            alert("Erreur : Problème de connexion avec la base de donnée");
          });
      }
      else {
        resolve("ok");
      }
    });
  }//fin loadJson

  loadFichier(url: string, type = "file") {

    let url2: string = this.url1 + url + this.url3;

    // url2 = "assets/quiz2.json";
    // alert(url2);
    const params = new FormData();
    params.append('para1', 'value1');
    params.append('type', type);

    return new Promise((resolve, reject) => {
      this.http.post(url2, params, { responseType: 'text' })
        .subscribe(data => {
          // alert(JSON.stringify(data));

          resolve(data);
        }, error => {
          alert(JSON.stringify(error));
        });
    });
  }//fin loadfichier


}
